

































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import MainLayout from '@/modules/common/layout/components/shared/MainLayout.vue'
import { ErrorMessages, FlushMessages } from '@/modules/common/layout/models/types/Messages'
import PanelTopHeader from '@/modules/common/layout/components/panel/PanelTopHeader.vue'
import PanelDrawer from '@/modules/common/layout/components/panel/PanelDrawer.vue'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import OverlayStore from '@/modules/common/layout/store/overlay.store'
import PopupNotificationGlobal from '@/modules/common/layout/components/shared/notification/PopupNotificationGlobal.vue'
import CtaButton from '@/modules/shared/components/shared/kit/CtaButton.vue'
import SocialIcon from '@/modules/shared/components/shared/icon/SocialIcon.vue'
import InitialPropsStore from '@/modules/common/layout/store/initial-props.store'

export interface VerificationStatusModel {
  email_notice: boolean
  sms_notice: boolean
  telegram_notice: boolean
}

@Component({
  metaInfo: {
    title: 'پنل مدیریت کاربر'
  },
  components: {
    SocialIcon,
    CtaButton,
    PopupNotificationGlobal,
    PanelDrawer,
    PanelTopHeader,
    MainLayout
  }
})
export default class PanelLayout extends MainLayout {
  constructor(
    private readonly userBootUseCase: UserBootUseCase,
    protected readonly overlayStore: OverlayStore,
    protected readonly initialProps: InitialPropsStore
  ) {
    super(overlayStore, initialProps)
  }

  $refs!: {
    panelDrawer: PanelDrawer
  }

  @Prop() sidebar!: object
  @Prop() orig_user!: string | null
  @Prop() unreadNotifications!: number
  @Prop() wallet_amount!: number | 0
  @Prop() current_user!: object
  @Prop() verification_status!: VerificationStatusModel

  @Prop() errors!: ErrorMessages
  @Prop() flush!: FlushMessages
  showDrawer = !this.$q.screen.lt.md
  showSwitchUser = false

  get showSwitchUserSync() {
    return this.showSwitchUser && !!this.orig_user
  }

  get loading() {
    return this.userBootUseCase.isLoading || false
  }

  public toggleDrawer() {
    this.$refs.panelDrawer.toggleDrawer()
  }

}
